import { render, staticRenderFns } from "./createRequest.vue?vue&type=template&id=35985ddf"
import script from "./createRequest.vue?vue&type=script&lang=js"
export * from "./createRequest.vue?vue&type=script&lang=js"
import style0 from "./createRequest.vue?vue&type=style&index=0&id=35985ddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports